module.exports = __webpack_public_path__ + "img/20.3e511dcc.png";